import React, { useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Menu from '@material-ui/core/Menu';

const StyledMenu = withStyles({
    paper: { border: '1px solid #d3d4d5' }
})((props) => (
    <Menu
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center'
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'center'
        }}
        {...props}
    />
));

function Filter(props) {

    useEffect(() => {
        props.setChecked([]);
    }, [props.clear]);

    function handleClose() {
        props.setAnchorElAT(null);
        props.setAnchorElBP(null);
        props.setAnchorElCategory(null);
        props.setAnchorElSS(null);
        props.setAnchorElAPP(null);
    }

    const handleChecked = (item) => {
        if (props.checked.includes(item.id)) {
            const currentState = props.checked.splice(props.checked.indexOf(item.id), 1, props.checked.splice(props.checked.indexOf(item.id + 1), 0));
            props.setChecked([...props.checked, currentState]);
        } else {
            props.setChecked([...props.checked, item.id]);
        }
    };


    function handleStyleComponent(anchorEl) {
        return (
            <StyledMenu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                keepMounted
            >
                <div className='category-body'>
                    <div className='categories'>
                        {props.item.filter && props.item.filter.filter((val) => val).map((item, itemI) => {
                            return (
                                <div className="category-item" key={itemI}>
                                    <input type='checkbox' name={`${item.name}[${props.index}]`} id={item.id}
                                        onChange={(e) => {
                                            props.onChangeHandler(e, props.item.name, item, item.id,);
                                            handleChecked(item);
                                        }} checked={props.checked.includes(item.id)} />
                                    <label htmlFor={item.name}>{item.name}</label>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </StyledMenu>
        );
    }
    function setStyleComponentEdit(name) {
        switch (name.toLowerCase()) {
            case "business process": {
                return handleStyleComponent(props.anchorElBP);
            }
            case "security stage": {
                return handleStyleComponent(props.anchorElSS);
            }
            case "automation type": {
                return handleStyleComponent(props.anchorElAT);
            }
            case "category": {
                return handleStyleComponent(props.anchorElCategory);
            }
            case "application": {
                return handleStyleComponent(props.anchorElAPP);
            }
            default: break;
        }
    }
    return (
        <>
            {setStyleComponentEdit(props.item.name)}
        </>
    );
}

export default Filter;
